import { __awaiter, __generator } from "tslib";
import { getUserStorageItem, setUserStorageItem, } from '@office-start/user-storage-service';
var ADMIN_ACQUIRED_APPS_USER_STORAGE_KEY = 'AdminAcquiredAppsUserData';
export function getAdminAcquiredAppsUserData(userStorageOptions) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getUserStorageItem(ADMIN_ACQUIRED_APPS_USER_STORAGE_KEY, userStorageOptions)];
        });
    });
}
export function setAdminAcquiredAppsUserData(userData, userStorageOptions) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, setUserStorageItem(ADMIN_ACQUIRED_APPS_USER_STORAGE_KEY, userData, userStorageOptions)];
        });
    });
}
//# sourceMappingURL=adminAcquiresAppsUserData.js.map